/**
 * Auditoría — GEN-PX-016/023. Botón del raíl (último grupo, Admin · Auditoría). Sus entradas (Detenciones, Saber) son las que el
 * kernel emite como hijos del ítem `auditoria` para este perfil (R-PT-02) y las lista el carril contextual junto al raíl; esta
 * pantalla solo abre la que el carril marca (`subId`, o la primera). Una entrada que el kernel emita y este front no conozca no se pinta.
 * La puerta real es de cada endpoint (R-PT-04).
 */
import { useSession } from '../context/SessionContext.jsx'
import { hijosDe } from '../lib/carril.js'
import { ID_AUDITORIA, itemAuditoria } from '../lib/auditoria.js'
import { useFotoAgente } from '../context/FotosAgentes.jsx'
import CabeceraLanding from './CabeceraLanding.jsx'
import DetencionesPanel from './DetencionesPanel.jsx'
import TrazaSaber from './TrazaSaber.jsx'

// Vista de cada tipo de apunte; añadir un tipo nuevo del kernel es una línea aquí.
const VISTAS = { detenciones: DetencionesPanel, saber: TrazaSaber }

export default function AuditoriaPanel({ subId = null, onNavegar = null, onAbrirAgente = null }) {
  const { capabilities, agents = [] } = useSession()
  const fotoDe = useFotoAgente()
  const menu = capabilities?.menu
  const entradas = hijosDe(itemAuditoria(menu), menu).filter(p => VISTAS[p.id])
  if (entradas.length === 0) return <section className="mec-visor" aria-label="Auditoría"><p className="dk-meta">No hay nada que auditar con tu perfil.</p></section>
  const activa = entradas.find(p => p.id === subId) ?? entradas[0]
  const Vista = VISTAS[activa.id]
  // GEN-PX-024: cabecera de Jorge que emite el kernel (cifras de 7 días de lo que este perfil ve); aquí solo se pinta.
  const cab = itemAuditoria(menu)?.cabecera
  const ag = cab?.agente && (agents.find(a => a.id === cab.agente.id) ?? cab.agente)
  const cifras = (cab?.cifras ?? []).filter(c => VISTAS[c.seccion]).map(c => ({ texto: c.texto, onClick: () => onNavegar?.(ID_AUDITORIA, c.seccion) }))
  return (
    <section className="dk-auditoria" aria-label="Auditoría">
      {cab && (
        <CabeceraLanding
          agente={ag ? { nombre: cab.agente.nombre, rol: cab.agente.rol, foto: fotoDe(ag) } : null}
          titulo={cab.titulo}
          texto={cab.texto}
          cifras={cifras}
        />
      )}
      <Vista key={activa.id} />
    </section>
  )
}
